// @flow

export { MerchantLogo } from './merchant-logo';
